
interface ConnectionHintProps {
  isConnecting: boolean;
}

export function ConnectionHint({ isConnecting }: ConnectionHintProps) {
  if (!isConnecting) return null;

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
      <div className="bg-indigo-600/90 backdrop-blur border border-indigo-400/40 rounded-xl px-4 py-2 text-xs text-white shadow-xl">
        Drop on a node body — no need to hit a socket · <span className="opacity-60">Esc to cancel</span>
      </div>
    </div>
  );
}
